"use client";

import { Download } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { formatBytes } from "./format";

export interface ProcessedImage {
  blob: Blob;
  /** Output filename without extension. */
  baseName: string;
  /** File extension (no dot), e.g. "png" or "jpg". */
  extension: string;
}

/** Result panel for image-producing tools (e.g. extract a video frame). */
export function ImageResultPanel({
  result,
  title = "Done",
}: {
  result: ProcessedImage;
  title?: string;
}) {
  const t = useTranslations("mediaTools.result.image");
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const next = URL.createObjectURL(result.blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [result]);

  const fileName = `${result.baseName}.${result.extension}`;

  return (
    <div className="space-y-3 rounded-lg border bg-card p-4">
      <p className="font-medium">{title}</p>
      {url && <img src={url} alt={t("alt")} className="max-h-80 w-full rounded object-contain" />}
      <Button asChild disabled={!url}>
        <a href={url ?? undefined} download={fileName}>
          <Download className="mr-2 h-4 w-4" />
          {t("download", { fileName, size: formatBytes(result.blob.size) })}
        </a>
      </Button>
    </div>
  );
}
